<template>
    <activities-calendar :get-activities-by-date="getActivitiesByDate('Aftercare')"
                         :get-activities-by-date-and-time="getActivitiesByDateAndTime('Aftercare')"
                         :activity-type="'Session'"
                         :mode="mode"
                         :calendar-date="calendarDate"
                         :date-format="dateFormat"
                         @change-date="changeActivityCalendarDate"
                         @change-mode="changeActivityCalendarMode"
                         @fetch-activities="() => getActivitiesCalendar({ activityType: 'Aftercare', schoolId })">
    </activities-calendar>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'AftercareCalendar',
        components: {
            ActivitiesCalendar: () => import(/* webpackChunkName: "calendar"*/ '@/components/controls/calendar/ActivitiesCalendar')
        },
        props: {
            schoolId: {
                type: [String, Number],
                required: true
            }
        },
        computed: {
            ...mapGetters({
                dateFormat: 'dateFormat',
                mode: 'activityCalendarMode',
                calendarDate: 'activityCalendarDate',
                getActivitiesByDate: 'getActivitiesByDate',
                getActivitiesByDateAndTime: 'getActivitiesByDateAndTime',
            })
        },
        methods: {
            ...mapActions([
                'getActivitiesCalendar',
                'changeActivityCalendarDate',
                'changeActivityCalendarMode'
            ])
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/pages/aftercare/AftercareCalendar.vue